import {
  ApiErrorMessagesInterface,
  ApiLoadingMessagesInterface,
  ApiSuccessMessagesInterface,
  ErrorMessagesInterface,
  PromptMessagesInterface,
} from './@core/interfaces';
import { getFileSize } from './@core/utilities/polly-manage.utilities';
import {
  MAX_FILE_SIZE_COPY_MOVE_RENAME_OPERATION,
  MAX_FOLDER_SIZE_COPY_MOVE_RENAME_OPERATION,
} from './modules/workspace-module/polly-manage-workspace.constants';

export const ApiErrorMessages: ApiErrorMessagesInterface = {
  FETCH_WORKFLOWS_ERROR: 'There was a problem in fetching all workflows.',
  FETCH_COMPONENTS_ERROR: 'There was a problem in fetching all components.',
  FETCH_WS_COLLABORATORS_ERROR: 'Cannot fetch all the Workspace permissions.',
  FETCH_USER_ERROR: 'There was an error in fetching user information.',
  WS_ALREADY_SHARE_ERROR: 'The Workspace is already shared with the user id.',
  SHARE_WS_YOURSELF_ERROR: `You can't share workspace with yourself.`,
  ADD_WS_PERMISSIONS_ERROR: 'User id not present on Polly.',
  MODIFY_WS_PERMISSIONS: 'There was a problem in modifying the workspace permissions.',
  REMOVE_WS_PERMISSIONS: 'There was a problem in revoking the workspace permissions.',
  CREATE_ANALYSIS_ERROR: 'There was a problem in creating analysis. Please try again.',
  FETCH_ANALYSIS_DETAILS: 'There was a problem in fetching analysis details. Please try again.',
  FILE_DOWNLOAD_ERROR: 'Could not download file',
  FETCH_REPOSITORIES_ERROR: 'There was a problem in fetching all repositories.',
  FETCH_WORKSPACES_ERROR: 'There was a problem in fetching all workspaces.',
  POLLY_PURCHASE_LICENSE_ERROR: 'There was a problem in initializing purchase request. Please try again.',
  FETCH_WORKSPACE_ERROR: 'There was problem in fetching all the workspaces.',
  FETCH_COMPONENT_INFO_ERROR: 'There was an error in fetching app info.',
  FETCH_LICENSE_INFO_ERROR:
    'There was some issue in fetching license, please reload.  If the issue persists, please contact customer service',
  TERMINATE_ANALYSIS: 'There was problem in terminating the analysis.',
  FETCH_ANALYSIS_RESTORE_URL: 'There was a problem in restoring the analysis.',
  FETCH_DATASETS_ERROR: 'There was a problem in fetching datasets. Please try again.',
  EXPLORER_COMPONENT_NOT_SELECTED_ERROR: 'Please select an application to open with.',
  FETCH_WORKSPACE_CONTENT_ERROR: 'Failed to get the contents of workspace.',
  CLONE_NOTEBOOK_ERROR: 'Failed to Clone Notebook',
  PDF_OPEN_ERROR: 'Failed to open this PDF.',
  REQUEST_DATASET_ERROR: 'There was a problem in sending the request. Please try again',
  COLLECTION_CREATION_ERROR: 'There was a problem in creating the collection. Please try again',
  COLLECTION_UPDATION_ERROR: 'There was a problem in updating the collection. Please try again',
  WORKSPACE_RESTORE_ERROR: 'Unable to restore workspace, please try again later.',
  PERMISSION_ERROR: 'Not enough permission to perform this action',
  DIY_POA_BUY_DATA_ERROR: 'We are looking into what went wrong. Please wait and we will get back to you soon.',
  DIY_POA_INSUFFICIENT_CREDITS: 'Please contact polly.support@elucidata.io to add more credits/permissions.',
  FETCH_SHORTLIST_DATA_ERROR: 'There was problem in fetching all the shortlisted items.',
  AT_LEAST_ONE_ADMIN_VALIDATION_MESSAGE: 'At least one ADMIN is required in Workspace'
};

export const ApiSuccessMessages: ApiSuccessMessagesInterface = {
  POLLY_PURCHASE_LICENSE_CONFIRMED: 'Your request for purchasing Polly has been noted. We will contact you shortly.',
  ADD_WS_PERMISSIONS_SUCCESS: 'Added collaborators to the workspace successfully',
  UPDATE_WS_PERMISSIONS_SUCCESS: 'Workspace Permissions updated successfully',
  CLONE_NOTEBOOK_SUCCESS: 'Notebook Clone successfully',
  REQUEST_DATASET_SUCCESS: 'Our team will reach out to you soon.',
  COLLECTION_CREATION_SUCCESS: 'Collection created  successfully',
  COLLECTION_UPDATION_SUCCESS: 'Collection  updated successfully',
  DIY_POA_BUY_DATA_SUCCESS: 'Datasets in shortlist has been sent for ingestion in your Atlas. We will notify you when the ingestion gets completed. Monitor Ingestion',
  WORKSPACE_RESTORE_SUCCESS: 'Workspace restored successfully! You can access the workspace in Active workspaces.',

  /* 3 different cases for creating notebooks, show success message according to the case:
  1. Creating notebook from workspace > New Analysis button
  2. Creating notebook from Applications > Polly Notebook
  3. Uploading a notebook, and editing and launching it first time (this is when notebook entry is created in database)
  */
  LAUNCH_NOTEBOOK_SUCCESS: 'Notebook launched successfully',
};

export const ApiLoadingMessages: ApiLoadingMessagesInterface = {
  FETCH_WS_PERMISSIONS: 'Fetching workspace permissions',
  ADD_WS_PERMISSIONS: 'Adding workspace permissions',
  MODIFY_WS_PERMISSIONS: 'Updating workspace permissions',
  REVOKE_WS_PERMISSIONS: 'Revoking workspace permissions',
};

export const PromptMessages: PromptMessagesInterface = {
  REMOVE_WS_PERMISSIONS: 'Are you sure that you want to delete this permission?',
};

export const ErrorMessages: ErrorMessagesInterface = {
  NO_SELECTED_APPLICATION: 'No selected application',
  INVALID_APPLICATION_TYPE: 'Invalid Application type',
  NO_ANALYSIS_NAME: 'Analysis Name not present',
  NO_REDIRECT_URL: 'Redirect URL not present',
  NO_NOTEBOOK_CONFIG: 'Notebook Config is required',
  NO_WORKSPACE_OR_ANALYSIS_NAME: 'Workspace or Analysis name not present',
  NO_INCLUDED_DATA: 'No included data present in response',
  NO_SELF_LINK: 'No Self URL present',
  FILE_PREVIEW_ERROR: 'Failed to open preview for this file',
  FILE_SHARE_ERROR: 'Failed to share this file',
  EXCEL_FILE_PARSE_ERROR: 'Unable to parse file, please download it for preview',
  ER_DIAGRAM_ERROR: 'Unable to load Entity Relationship Diagram. Please try again later.'
};

export const FILE_SIZE_EXCEEDS_MESSAGE: string = `operation is not supported for files/notebooks of size greater than ${getFileSize(MAX_FILE_SIZE_COPY_MOVE_RENAME_OPERATION)}.`;
export const FOLDER_SIZE_EXCEEDS_MESSAGE: string = `operation is not supported for folders of size greater than ${getFileSize(MAX_FOLDER_SIZE_COPY_MOVE_RENAME_OPERATION)}.`;
export const FOLDER_CONTAINS_LARGE_FILES: string = `operation is not supported for folders with files/notebooks of size greater than ${getFileSize(MAX_FILE_SIZE_COPY_MOVE_RENAME_OPERATION)}.`;
